export default __webpack_public_path__ + "static/media/api.264721b8.txt";